import { defineMessages } from 'react-intl'

export default defineMessages({
  usersHeadline: {
    id: 'app.users.headline',
    defaultMessage: 'Users',
  },
  usersAddUser: {
    id: 'app.users.addUser',
    defaultMessage: 'Add User',
  },

  usersProfileHeadline: {
    id: 'app.users.profile.headline',
    defaultMessage: 'Profile',
  },

  // Settings / Notification page
  userNotificationsHeadline: {
    id: 'app.users.notifications.headline',
    defaultMessage: 'Notifications',
  },
  userNotificationsChatNotificationsTitle: {
    id: 'app.users.settings.userNotificationsChatNotificationsTitle',
    defaultMessage: 'Chat notifications',
  },
  userNotificationsChatNotificationsSubtitle: {
    id: 'app.users.settings.userNotificationsChatNotificationsSubtitle',
    defaultMessage: 'Receive push notifications for new messages',
  },
  userNotificationsDocumentsNotificationsTitle: {
    id: 'app.users.settings.userNotificationsDocumentsNotificationsTitle',
    defaultMessage: 'Documents notifications',
  },
  userNotificationsDocumentsNotificationsSubtitle: {
    id: 'app.users.settings.userNotificationsDocumentsNotificationsSubtitle',
    defaultMessage: 'Receive push notifications for new documents',
  },
  userNotificationsAllDisabled: {
    id: 'app.users.settings.allDisabled',
    defaultMessage: 'Notifications are currently not allowed',
  },

  // Placeholder messages
  placeholderFirstName: {
    id: 'app.users.placeholder.firstName',
    defaultMessage: 'First name',
  },
  placeholderLastName: {
    id: 'app.users.placeholder.lastName',
    defaultMessage: 'Last name',
  },
  placeholderEmail: {
    id: 'app.users.placeholder.email',
    defaultMessage: 'Email address',
  },

  // Validation messages
  validationFirstNameRequired: {
    id: 'app.users.validation.firstNameRequired',
    defaultMessage: 'First name is required!',
  },
  validationLastNameRequired: {
    id: 'app.users.validation.lastNameRequired',
    defaultMessage: 'Last name is required!',
  },
  validationEmailRequired: {
    id: 'app.users.validation.email',
    defaultMessage: 'Email is required!',
  },
  validationEmailNotValid: {
    id: 'app.users.validation.emailNotValid',
    defaultMessage: 'The input is not valid email',
  },

  // Messages (error/success)
  messageUserIdNotProvided: {
    id: 'app.users.message.userIdNotProvided',
    defaultMessage: 'User ID not provided',
  },

  profileNotifications: {
    id: 'app.users.profile.notifications',
    defaultMessage: 'Notifications',
  },

  profileYourProfile: {
    id: 'app.profile.yourProfile',
    defaultMessage: 'Your profile',
  },
})
